module.exports = __webpack_public_path__ + "static/media/29ADMSPC18.fe28bd91.jpg";